<template>
    <vs-popup class="add-new-incoterms" id="popup" title="UPLOAD LEAD SHEET" @close="open = false" :active.sync="open"
        :buttons-hidden="true">

        <div class="vx-row mx-8">
            <div class="vx-col w-1/2">
                <vx-card noShadow cardBorder>
                    <vs-button @click.stop="downloadSheet" icon-pack="feather" icon="icon-download">download upload
                        template</vs-button> <br>
                    <vs-alert color="danger" class="h-auto" title="Note">
                        Any user record without an email addrress will be rejected as a lead on upload.
                    </vs-alert>
                </vx-card>
            </div>
            <div class="vx-col w-1/2">
                <vx-card noShadow cardBorder>
                    <form @submit="uploadFile" class="mt-8">
                        <input type="file" ref="fileInput" @change="handleFileUpload" accept=".xlsx, .xls, .csv"> <br>
                        <small>.xlsx .xls .csv</small> <br>
                        <div class="flex flex-wrap items-center justify-end mt-8">
                            <vs-button class="mt-8" @click="uploadFile">Upload</vs-button>
                        </div>
                    </form>
                </vx-card>
            </div>
        </div>
        <div class="vx-row mx-8 mt-4 hidden">
            <div class="vx-col w-1/2">
                <vx-card noShadow cardBorder>
                    <form @submit="uploadFile" class="mt-8">
                        <input type="file" ref="fileInput" @change="handleFileUpload" accept=".xlsx, .xls, .csv"> <br>
                        <small>.xlsx .xls .csv</small> <br>
                        <div class="flex flex-wrap items-center justify-end mt-8">
                            <vs-button class="mt-8" @click="uploadFile">Upload</vs-button>
                        </div>
                    </form>
                </vx-card>
            </div>
        </div>
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import axios from '@/axios'

function initialState() {
    return {
        open: false,
        file: null,
        excelFilePath: ''
    }
}

export default {
    name: 'UploadMarketingLeadSheetPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true;
            } catch (error) {

            }
        },
        handleFileUpload(event) {
            this.file = event.target.files[0];
        },
        uploadFile(event) {
            event.preventDefault();

            if (!this.file) {
                // No file selected, handle error
                return;
            }

            const formData = new FormData();
            formData.append('file', this.file);
            this.$vs.loading()
            axios.post('/admin/bulk-upload/external/mail-chimp', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(response => {
                    // Handle success
                    this.open = false
                    this.$vs.dialog({
                        color: 'primary',
                        title: `Upload summary`,
                        text: response.data.data.message,
                        acceptText: 'Close'
                    })
                    this.$parent.refreshData()
                })
                .catch(error => {
                    this.convertAndNotifyError(error)
                })
                .finally(res => {
                    this.$vs.loading.close()
                });
        },
        async downloadSheet() {
            try {
                const response = await CrmRepository.downloadExcelTemplate()
                let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                let fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', `bulk upload template.xlsx`);
                document.body.appendChild(fileLink);
                fileLink.click();
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        }
    },
    components: {
        'v-select': vSelect,
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    /* min-height: 30% !important; */
    min-width: 50% !important;
}
</style>
  